import { Button } from "antd";
import { useIntl } from "react-intl";
import { NotificationStatuses } from "~enums/notificationStatuses.ts";
import { NotificationItemBody } from "~pages/Notifications/components/NotificationItemBody.tsx";
import { useMarkAsReadNotification } from "~pages/Notifications/hooks/useMarkAsReadNotification.ts";
import type { Notification } from "~types/notification.ts";

type Props = {
  notification: Notification;
};

export const ReportNotificationItem = ({ notification }: Props) => {
  const { formatMessage } = useIntl();
  const { mutateAsync: markAsRead } = useMarkAsReadNotification();

  const customButtons =
    notification.status === NotificationStatuses.Completed && notification?.data?.DownloadUrl
      ? [
          <Button
            type="primary"
            key="download"
            href={notification.data.DownloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
            onClick={() => markAsRead(notification.key)}
          >
            {formatMessage({ id: "download" })}
          </Button>,
        ]
      : [];

  return <NotificationItemBody notification={notification} icon="fa-file-export" customButtons={customButtons} />;
};
